<template>
    <div id='repertory' style="width:100%;heigh:100%;">
        <el-card class="table_searchbar">
            <el-row :gutter="20">
                <el-col :span="5">
                    <div class="" @keydown.enter="btnSearch()">
                        <span class="title">物料编码： </span>
                         <el-input style="max-width:180px" size="small" v-model="searchForm.materialCode"  maxlength="20" placeholder="物料编码"></el-input>
                    </div>
                </el-col>
                <el-col :span="5">
                    <div class="">
                        <span class="title">物料名称： </span>
                        <el-select clearable filterable remote :remote-method="query=>this.remoteMethod('',query)" :loading="loading" @visible-change="changeToOldData" @change="materialChange" size="small" style="max-width:180px" v-model="searchForm.materialId"   placeholder="物料名称"  >
                            <el-option v-for="item in materialList" :key="item.id" :label="item.materialName?item.materialName:' '" :value="item.id">
                                {{item.materialName}}
                            </el-option>
                        </el-select>
                    </div>
                </el-col>
                <el-col :span="5">
                    <div class="">
                        <span class="title">物料规格： </span>
                        <el-select clearable filterable remote :remote-method="query=>this.remoteMethod('','',query)" :loading="loading" @visible-change="changeToOldData" @change="materialChange" size="small" style="max-width:180px" v-model="searchForm.materialId"   placeholder="物料规格"  >
                            <el-option v-for="item in materialList" :key="item.id" :label="item.specification?item.specification:' '" :value="item.id">
                                {{item.specification}}
                            </el-option>
                        </el-select>
                    </div>
                </el-col>
                <el-col :span="5">
                    <div class="">
                        <span class="title">物料批次： </span>
                         <el-select size="small" style="max-width:180px" v-model="searchForm.productionBatch"   placeholder="物料批次"  filterable>
                            <el-option v-for="item in productionBatchList" :key="item" :label="item" :value="item"></el-option>
                        </el-select>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div style="text-align:right">
                        <a style="margin-right: 12px;cursor: pointer;font-size: 12px;" @click="toggleShowMore">
                            {{ showMore ? '收起' : '展开' }}
                            <i :class="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
                        </a>
                        <el-button size="mini" icon="el-icon-search" type="primary" @click="btnSearch()">查询</el-button>
                        <el-button size="mini" icon="el-icon-refresh" @click='clearSearch'>重置</el-button>
                    </div>
                </el-col>
            </el-row>
            <el-collapse-transition>
                <div v-show="showMore">
                    <el-row :gutter="20">
                        <el-col :span="5">
                            <div class="">
                                <span class="title">仓库： </span>
                                <el-select @change="factoryChange($event)" clearable filterable v-model="searchForm.factoryWarehouseId" style="max-width:180px"  placeholder="仓库"  >
                                    <el-option v-for="item in factoryModelList" :key="item.id" :value="item.id" :label="item.name"></el-option>
                                </el-select>
                            </div>
                        </el-col> 
                        <el-col :span="5">
                            <div class="">
                                <span class="title">库位： </span>
                                <el-select clearable filterable v-model="searchForm.factoryPositionId" style="max-width:180px"  placeholder="库位"  >
                                    <el-option v-for="item in factoryPositionList" :key="item.factoryId" :label="item.factoryName" :value="item.factoryId"></el-option>
                                </el-select>
                            </div>
                        </el-col> 
                    </el-row>
                </div>
            </el-collapse-transition>
        </el-card>
        <el-card class="table-card">
            <el-row >
                <el-button type="primary"  @click="printData">打印</el-button>
                <el-button  v-if="permission.btn_stock_exportStock"  type='primary' @click="exportData">导出</el-button>
            </el-row>
            <div style="display:flex">
                <el-table :data="tableData"  style="width: 65%" class="stock-Table"  @row-click='rowClick' :row-style='selectedHighlight' :row-class-name="selectedClass" border>
                    <el-table-column prop="materialCode" label="物料编码" min-width="80"  show-overflow-tooltip></el-table-column>
                    <el-table-column prop="materialName" label="物料名称"  min-width="80" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="specification" label="物料规格"  min-width="80" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="totalAmount" label="总数量" min-width="80" show-overflow-tooltip>
                        <template slot-scope="scope" >
                            <el-button  type="text">{{scope.row.totalAmount}}<i  style="margin-left: 6px;" class="el-icon-view"></i></el-button>
                        </template>
                    </el-table-column>
                    <el-table-column prop="unitType" label="单位" min-width="80" show-overflow-tooltip></el-table-column>
                </el-table>

                <el-table :data="stockDetailList" stripe style="width: 35%;margin-left:20px" border>
                    <el-table-column prop="factoryWarehouseName" label="仓库" min-width="80" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="factoryPositionName" label="库位" min-width="80" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="productionBatchCode" label="批次" min-width="80" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="itemAmount" label="数量" min-width="80" show-overflow-tooltip></el-table-column>
                </el-table>
            </div>

            <div class="page" v-if="tableData.length > 0">
                <div class="total_page"><span> 共{{tableTotalPage}}条 10条/页</span></div>
                <div style="margin-top:10px;text-align:right; margin-bottom:20px;" >
                    <el-pagination background layout="prev, pager, next" :total="tableTotalPage" @current-change="pageChange" :current-page="tableCurrentPage">
                    </el-pagination>
                </div>
            </div>
        </el-card>
        <!-- 查看点检点检开始 -->
        <el-dialog title="锁定仓库" @close="cancelViewDialog"  :visible.sync="viewDialogVisible" :width="span==5?'36%':'55%'" center :close-on-click-modal="false">
            <el-table :data="lockList" stripe  border>
                <el-table-column prop="productionBatchCode" label="批次号" min-width="80" show-overflow-tooltip></el-table-column>
                <el-table-column prop="planStartTime" label="计划时间" min-width="80" :formatter='$commonUtil.changeToDate' show-overflow-tooltip></el-table-column>
                <el-table-column prop="needAmount" label="需求数量" min-width="80" show-overflow-tooltip></el-table-column>
                <el-table-column prop="stockAmount" label="库存数量" min-width="80" show-overflow-tooltip></el-table-column>
                <el-table-column  label="操作" min-width="80" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-button @click="releaseStock(scope.row.id)"  type="text" size="small">释放</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelViewDialog" type="primary">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 新增点检配置结束 --> 
    </div>
</template>

<script>


export default {
    name: 'Repertory',
	data () {
        return {
            showMore:false,
            rowDataId:null,
            lockList:[],
            selectId:null,
            productionBatchList:[],
            factoryPositionList:[],
            stockDetailList:[],
            factoryModelList:[],
            fristLoad:false,
            oldData:[],
            materialList:[],
            loading:false,
            showData:true,
            workerBar:null,
            selectData:{},
            searchList:[],
            storeSelect:1,
            batchOption:[],
            configOption:[],
            storeOption:[
                {id:1,name:'按仓库统计'},
                {id:2,name:'按库区统计'},
                {id:3,name:'按库位统计'}
            ],
            W:false,
            btnPressType: 0,//按钮类型： 0-默认 1-查询 2-重置 3-分页
            searchFormTemp: '',//临时搜索数据
            searchForm:{
                workingLevel:null,
                configName:'',
                factoryPositionId:null,
                factoryWarehouseId:null,
                productionBatch:'',
                materialCode:'',
            },
            viewForm : {
            },
            tableData:[],
            tableCurrentPage:1,
            tableTotalPage:2,
            viewDialogVisible:false,
            data: {
				token: localStorage.getItem("token"),
            },
            permission:JSON.parse(localStorage.getItem("permission")),
            selectItem:null 
             
        }
    },
    mounted:function(){
         this.initTable();
         this.loadMaterialList()
         this.loadFactoryModelList()
        let w  = document.documentElement.clientWidth || document.body.clientWidth;
        w>=1900?this.W = true:this.W = false
        window.onresize=()=>{
            let w  = document.documentElement.clientWidth || document.body.clientWidth;
            w>=1900?this.W = true:this.W = false
        }
    },
    computed:{
        span(){
           return this.W?5:7
        }
    },
    deactivated:function(){
        
    },
    methods:{
        toggleShowMore(){
            this.showMore = ! this.showMore
        },
        async rowClick(row, column, event){
            this.selectId = row.id
            if (column.property == 'totalAmount') {
                await this.showViewDialog(row)
                return
            }
            this.stockDetailList = await this.loadDetail(this.selectId)
            this.stockDetailList.forEach(item=>{
                item.materialName = row.materialName
                item.materialCode = row.materialCode
                item.specification = row.specification
                item.unitType = row.unitType
            })
        },
        
        selectedHighlight({row, rowIndex}) {
            if ((this.selectId) ==row.id ) {
                return {
                    "background-color": "#409EFF",
                    'color':'#fff',
                    cursor: 'pointer'
                };
            }
            return {cursor: 'pointer'}
        },

        selectedClass({row, rowIndex}){
            if ((this.selectId) ==row.id ) {
                return 'select-row';
            }else{
                return ''
            }
        },

        async loadDetail(id){
            let res = await this.$RequestUtil.getAsync({url: '/api/stock/listStockById',params: {
                id,
                materialId:this.searchForm.materialId,
                productionBatch:this.searchForm.productionBatch,
                factoryPositionId:this.searchForm.factoryPositionId,
                factoryWarehouseId:this.searchForm.factoryWarehouseId,
            }})
            return res.data
        },

        async loadFactoryModelList(id){
            let res = await this.$RequestUtil.getAsync({url: '/api/select/listDefaultMaterialFactoryModel',params: {id}})
            this.factoryModelList = res.data
        },

        async loadWarehouseLocationByWarehouseId(warehouseId) {
            let {data} = await this.$RequestUtil.getAsync({ url: '/api/select/getWarehouseLocationSelect',  params: { warehouseId }, })
            this.factoryPositionList = data
        },

        async factoryChange(ev){
            this.$set(this.searchForm,'factoryPositionId',null)
            await this.loadWarehouseLocationByWarehouseId(ev)
        },

        async loadProductionBatchList(id){
            let res = await this.$RequestUtil.getAsync({url: '/api/select/listStockProductionBatch',params: {id}})
            this.productionBatchList = res.data
        },

        printData(){
            localStorage.setItem('printStockType',2)
            
            localStorage.setItem('printStockInfo',JSON.stringify(this.stockDetailList))
            let routeUrl = this.$router.resolve({path: "/Print/PrintStock"});
			window.open(routeUrl.href, '_blank');
        },

        exportData(){
            this.$confirm('是否导出库存数据?', '提示', {
                cancelButtonClass: "btn-custom-cancel",
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                let { code, data } = await this.$RequestUtil.getAsync({
                    url: "/api/auth/checkToken",
                    type: 'sync',
                    params: {},
                })
                if (data == 0 || (code != 0)) {
                    this.$message.error('当前登录已过期')
                    localStorage.removeItem("token");
                    localStorage.removeItem("username");
                    localStorage.removeItem("permission");
                    this.$router.push({ path: "/login" })
                    return
                }

                
                let temp = this.searchForm
                let params = {
                    materialId:temp.materialId,
                    warehouseId:temp.warehouseId,
                    productionBatch:temp.productionBatch,
                    specification:temp.specification,
                    factoryWarehouseId:temp.factoryWarehouseId,
                    factoryPositionId:temp.factoryPositionId,
                    materialCode:temp.materialCode,
                    token:localStorage.getItem("token")
                }
                let str = '?'
                for(let p in params){
                    if(params[p]||params[p]===0){
                        str+=`${p}=${params[p]}&`
                    }
                }
                if(str.endsWith('&')){
                    str = str.slice(0,str.length-1)
                    window.location.href = '/api/stock/exportStock'+str;
                }
                // this.$RequestUtil.get({
                //     url: '/api/stock/exportStock',
                //     type: 'sync',
                //     params:{
                //         materialId:temp.materialId,
                //         warehouseId:temp.warehouseId,
                //         productionBatch:temp.productionBatch,
                //         specification:temp.specification,
                //         factoryWarehouseId:temp.factoryWarehouseId
                //     },
                //     success: (res) => {
                //         // if (res.code) {
                //         //     this.$message.error(res.msg || res.message)
                //         // } else {
                //             window.location.href = url
                //         // }
                //     }
                // })
            })
        },

        changeToOldData(ev){
            if(!ev){
                let find = this.oldData.find(item=>item.id==this.selectItem.id)
                if(!find){
                    this.oldData.unshift(this.selectItem)
                }
                this.materialList = this.oldData
                
            }
        },

        async materialChange(ev){
            this.materialList.forEach(item=>{
                if(item.id == ev){
                    this.batchOption = item.batchList
                    this.selectItem = item
                }
            })
            this.$set(this.searchForm,'productionBatch','')
            await this.loadProductionBatchList(this.searchForm.materialId)
        },

        hasData(){
            if(this.showData){
                return true
            }else{
                return false
            }
        },

        async loadMaterialList(code,materialName,specification){
            if(code==null||code==undefined){
                code = ''
            }
            let res = await this.$RequestUtil.getAsync({url: '/api/select/listMaterialName',type:'async',params: {code,materialName,specification}})
            if(!code&&!materialName&&!specification){
                this.oldData = res.data
                this.materialList = res.data
            } 
            res.query = code||materialName||specification
            return res
        },

        async remoteMethod(code,materialName,specification) {
            this.loading = true;
            let res = await this.loadMaterialList(code,materialName,specification)
            if(res.query == code||res.query == materialName||res.query == specification){
                this.loading = false
                this.materialList = res.data
            }
        },

       
        btnSearch:function(){
            this.tableCurrentPage = 1;
            this.btnPressType = 1
            this.search();
        },

        clearSearch(){
            let form = this.searchForm;
            this.btnPressType = 2;
            form.productionBatch='';
            form.materialId=null;
            form.specification = ''
            form.factoryWarehouseId = null
            form.factoryPositionId = null
            form.materialCode = ''
        },

        search:function(){
            let temp;
            switch (this.btnPressType) {
              case 1:
                temp = commonUtils.cloneObj(this.searchForm);
                this.searchFormTemp = commonUtils.cloneObj(temp);
                break;
              case 0:
                temp ={
                    materialId:null,
                    warehouseId:null,
                    productionBatch:null,
                    specification:'',
                    factoryWarehouseId:null,
                    factoryPositionId:null,
                    materialCode:'',
                };
                break;
              case 2:
                temp = this.searchFormTemp;
                break;
              case 3:
                temp = this.searchFormTemp;
                break;
            }
            this.$RequestUtil.get({
                url: '/api/stock/listStock',
                type:'sync',
				params: {
                    pageNum:this.tableCurrentPage,
                    pageSize:10,
                    materialId:temp.materialId,
                    warehouseId:temp.warehouseId,
                    productionBatch:temp.productionBatch,
                    specification:temp.specification,
                    factoryPositionId:temp.factoryPositionId,
                    factoryWarehouseId:temp.factoryWarehouseId,
                    materialCode:temp.materialCode,
                    
                },
                success: async (res) => {
                    if(res.msg == this.$Global.RESPONSE.SUCCESS){
                        this.tableData = res.data;
                        this.tableTotalPage = res.totalPages;
                        if(res.totalPages == 0&&this.fristLoad){
                            this.$message.warning('查询不到符合条件的数据');
                        }
                        if(res.data.length>0){
                            this.selectId = res.data[0].id
                            let row = res.data[0]
                            this.stockDetailList = await this.loadDetail(this.selectId)
                            this.stockDetailList.forEach(item=>{
                                item.materialName = row.materialName
                                item.materialCode = row.materialCode
                                item.specification = row.specification
                                item.unitType = row.unitType
                            })
                        }else{
                            this.stockDetailList = []
                        }

                        this.fristLoad = true
                    }else{
                        this.$message.error(res.message||res.msg)
                    }
                }
            }); 
        },

        pageChange:function(targetPage){
            this.tableCurrentPage = targetPage;
            this.btnPressType = 3;
            this.search();
        },

        initTable:function(){
            this.search();
        },
        
        async loadLockList(id) {
            let {data} = await this.$RequestUtil.getAsync({ url: '/api/stock/getStockLockRecord',  params: { id }, })
            return data
        },

        async showViewDialog(rowData){
            this.rowDataId = rowData.id
            this.lockList = await this.loadLockList(rowData.id)
            this.viewDialogVisible = true;
        }, 

        cancelViewDialog(){
            this.viewDialogVisible= false
        },

        async releaseStock(id){
             this.$confirm('释放库存后不可撤回,是否确认释放库存?', '提示', {
                cancelButtonClass: "btn-custom-cancel",
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                let {code,msg,message} = await this.$RequestUtil.postAsync({ url: '/api/stock/releaseStock',  params: { id }, })
                if(code==0){
                    this.$message.success('释放成功')
                    this.lockList = await this.loadLockList(this.rowDataId)
                }else{
                    this.$message.error(msg||message)
                }
            })
            
        },

    }
}
</script>

<style scoped>
.table_searchbar .title11{
    color: #606266;
    font-family: NotoSansHans-Regula;
    font-size: 14px;
}

 .value{
    display:inline-block
}
.el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
}



.page{
    display: flex;
    justify-content: flex-end;
}
@media screen and (max-width: 1450px){
    .page{
        display: flex;
        justify-content: flex-end;
        margin-bottom:30px;
    }
}
.total_page{
    margin-top: 20px;
    margin-right: 26px;
    color:#606266;
    font-size: 14px;
}

</style>
<style>
    #repertory .stock-Table  .el-table__body tr:hover > td,#repertory .stock-Table  .el-table__body tr:hover > td .el-button--text {
        color: red;
        background-color: green;
    }

    #repertory .stock-Table  .el-table__body .select-row .el-button--text {
        color:#fff;
        
    }
    
</style>




// WEBPACK FOOTER //
// src/views/stock/Repertory.vue